export function simplifyLine(points) {
  var result = points.reduce((uniqueElements, o) => {
    if (!uniqueElements.some((obj) => obj.x === o.x && obj.y === o.y)) {
      uniqueElements.push(o);
    }
    return uniqueElements;
  }, []);

  return result;
}